module.exports = __webpack_public_path__ + "img/register-close-btn.f8976b9b.svg";